export const submitValidation = (event) => {
    let submitErrors = [];
    if (!event.consent)     submitErrors.push('You must agree that claims are truthful and consent to a random audit.');
    if (event.error)        submitErrors.push('Something went wrong with your claim submission. You can try again or contact customer-support-uk@agconnect.org for more information.');
	return submitErrors.filter(d => d);
}